/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-09-02 16:49:07
 * @modify date 2021-09-02 16:49:07
 * @desc 订单
 */
import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { computed } from 'mobx';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../helpers';
import { BaseModel, BasesController } from '../bases';
@BindAll()
export class SECController<T = any> extends BasesController<T> {
  constructor() {
    super();
    this.reset({
      dataKey: 'key',
      infinite: true,
      details: EnumAPI.sec_orders_details, // 根据状态调用的接口不同
      pagination: EnumAPI.sec_orders_list,
      paginationParams: {
        currentKey: 'pageNo',
        pageSizeKey: 'pageSize',
        filterKey: 'search',
        response: { valueGetter: this.paginationValueGetter },
      },
    });
  }
  /**
   * 加载详情数据
   * @param body
   * @param AjaxConfig
   * @returns entity
   */
  async onFind(body?: string | number | { [key: string]: any }) {
    const orderStatus = lodash.toString(lodash.get(body, 'orderStatus'));
    return this.Details.onLoad(
      body,
      lodash.includes(['1', '5'], orderStatus) ? EnumAPI.orders_alldetails : {},
    );
  }

  Model = new BaseModel({ type: 'object', storageKey: 'order_status' });

  /**
   * 订单全部状态
   */
  @computed
  get OrderStatus(): Array<any> {
    // return this.Model.get('OrderStatus', [])
    return lodash.get(this.Model.value, 'OrderStatus', []);
  }

  /**
   * 物流信息
   */
  @computed
  get logisticsList(): Array<any> {
    return lodash.get(this.Model.value, 'logisticsList', []);
  }

  /**
   * 转换列表数据
   * @param response
   * @returns
   */
  paginationValueGetter(response) {
    let list = lodash.get(response, 'list', []);
    const dataSource = lodash.map(list, (val, key) => {
      // 求总价格
      // const dealPrice = lodash.sumBy(val, (prt) => multiply(prt));
      const actionList = [];
      return {
        ...val,
        key: val.id + val.productCode,
        actionList,
        confirm: val.confirm == 1 ? '已确认' : '待确认',
      };
    });
    console.log(
      'LENG ~ OrdersController<T ~ dataSource ~ dataSource',
      dataSource,
    );
    return {
      total: lodash.get(response, 'count'),
      dataSource,
    };
  }

  /**
   * @ 取消订单
   */
  async orderCancel(body) {
    //
    return await AjaxBasics.request({ ...EnumAPI.order_cancel, body });
  }

  async confirmOgders(body) {
    return await AjaxBasics.request({ ...EnumAPI.sec_confirm, body });
  }
}
